import React from 'react';
import '../css/about.css'
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../../components/css/join_us.css'

function AboutContent() {
  return (
<di>


    <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Image column */}
          
              {/* Text column */}
              <Col
                md={12}
                className="d-flex align-items-center order-2 order-md-2"
              >
                <div>
                  <h1 className="custom_heading">Who is Kontriman?</h1>
                  <p>
                    Kontriman is a Category 1 Microfinance Institution Registered under Minader: 23/049/CMR/SW/53/279/CCA/036004/03600400 with regulatory approvals from Cobac: D-2024/354, Minfi: 00000041/2024, NIU:M042318452491L. Our Head Office is in Limbe, South West Region, Cameroon. Founded to Bridge the Financial gap ignored by traditional Banks, Kontriman is committed to financial inclusion, trust, and tailored solutions. Instead of waiting for change, we created it building a system that empowers individuals and businesses.

                    <br /><br />
                  Today, we provide innovative banking solutions that go beyond transactions, helping our clients save, grow, and thrive. At Kontriman, we don’t just offer financial services we build financial futures.
                  </p>

                  <h5 className="mt-4">Key Features</h5>
                  <ul>
                    <li>
                      Competitive interest rates and flexible repayment terms
                    </li>
                    <li>Tailored limits to suit your business needs</li>
                    <li>Access to working capital when needed</li>
                    <li>Dedicated relationship manager support</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>Registered business with valid documentation</li>
                    <li>Good credit standing</li>
                    <li>Minimum operational history of 12 months</li>
                  </ul>

                  <a href="/login">
                    <Button className="custom-button mt-3">Create An Account</Button>
                  </a>
                </div>
              </Col>
              
            </Row>
          </Container>
        </Container>
      </div>
</di>
  );
}

export default AboutContent;
